// extracted by mini-css-extract-plugin
export default {"accountContainer":"Account_accountContainer__xKyVp","accountCard":"Account_accountCard__L31Mx"};